import { render } from "./login.vue?vue&type=template&id=6e8fa1e5"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import exportComponent from "E:\\RedCigar\\Vue\\RedCigar_C_T_Template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__